import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import {
  FormControl,
  InputLabel,
  Typography,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SpecialtySearch } from './SpecialtySearch';
import { SpecialtyUtil } from 'doctivity-shared/utils';

const styles = (theme) => ({
  filterDropDown: {
    width: 168,
    marginRight: theme.spacing(),
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  lockIcon: {
    fontSize: 'inherit',
    verticalAlign: 'text-top',
    marginRight: 2,
    paddingRight: 6,
    color: '#999999',
  },
  parentServiceline: {
    borderTop: '1px solid #cccccc',
  },
  subServiceline: {
    fontSize: 14,
    paddingLeft: theme.spacing(4),
  },
  button: {
    padding: 0,
    textTransform: 'none',
  },
  select: {
    width: '100%',
  },
});

class TaxonomySelect extends React.Component {
  constructor(props) {
    super(props);

    let label = this.getLabel('All', props.values);

    this.state = {
      specialtiesTreeOpen: false,
      label: label,
      updateSpecialties: true
    };

  }

  render() {
    const { classes, values } = this.props; 

    const { label, specialtiesTreeOpen } = this.state;

    return (
      <>
        <FormControl
          variant='outlined'
          className={classes.filterDropDown}
          key='filter-taxonomy'
        >
          <InputLabel>Specialties</InputLabel>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();

              this.openSpecialtiesTreeDialog();
            }}
            className={classes.button}
            disableRipple
          >
            <Select
              value='custom'
              label='Specialties'
              open={false}
              className={classes.select}
              renderValue={() => {
                return (
                  <Typography align='left' noWrap>
                    {label}
                  </Typography>
                );
              }}
            >
              <MenuItem value='custom'></MenuItem>
            </Select>
          </Button>
        </FormControl>
        
     
        {(true && <SpecialtySearch
            open={specialtiesTreeOpen}
            clientId={app.selectedClient}
            onClose={this.closeSpecialtiesTreeDialog}
            allowMultiple={true}
            onChange={this.onSpecialtiesTreeChangeChange}
            values={values}
            //onRowClick={(provider) => this.onRowClick(provider)}
          />
        )}
      </>
    );
  }

  getLabel = (defValue, values) => {
    if (values) {
      if (values.length > 1) {
        defValue = values.length + ' specialties';
      }

      if (values.length == 1) {
        // Handle both taxonomy objects and raw code strings
        if (typeof values[0] === 'string') {
          defValue = values[0]; // show code as fallback
          // Try to resolve from taxonomyCodes prop
          const tcData = this.props.taxonomyCodes?.data?.rows || this.props.taxonomyCodes?.data;
          if (Array.isArray(tcData)) {
            const found = tcData.find(t => t.code === values[0]);
            if (found) {
              defValue = SpecialtyUtil.getNameFromTaxonomy(found);
            }
          }
        } else {
          defValue = SpecialtyUtil.getNameFromTaxonomy(values[0]);
        }
      }
    }

    return defValue;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.values !== this.props.values || 
        prevProps.taxonomyCodes !== this.props.taxonomyCodes) {
      const label = this.getLabel('All', this.props.values);
      if (label !== this.state.label) {
        this.setState({ label });
      }
    }
  }

  onClearSpecialtiesTree = () => {
      this.props.onChange([]);
  };

  onSpecialtiesTreeChangeChange = (selectedTaxonomies) => {
    if (selectedTaxonomies.length > 500) {
      selectedTaxonomies = [];
    }

    var label = this.getLabel('All', selectedTaxonomies);

    this.props.onChange(selectedTaxonomies);
    this.closeSpecialtiesTreeDialog();
    this.setState({ label });
  };

  openSpecialtiesTreeDialog = () => {
    this.setState({ specialtiesTreeOpen: true });
  };

  closeSpecialtiesTreeDialog = () => {
    this.setState({ specialtiesTreeOpen: false });
  };
}

TaxonomySelect.propTypes = {
  classes: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.array,  
};



function mapStateToProps() {
  return {};
}

const styled = withStyles(styles)(TaxonomySelect);
const connected = connect(mapStateToProps)(styled);
export { connected as TaxonomySelect };